import React, { useState } from "react";
import { useGame } from "../context/GameContext";
import { useTimer } from "../hooks/useTimer";

const AVATARS = [
  { emoji: "🦊", bg: "#ff3e3e22", border: "#ff3e3e", text: "#ff3e3e" },
  { emoji: "👾", bg: "#9b6dff22", border: "#9b6dff", text: "#9b6dff" },
  { emoji: "🦖", bg: "#3effa322", border: "#3effa3", text: "#3effa3" },
  { emoji: "🐱", bg: "#f5c84222", border: "#f5c842", text: "#f5c842" },
  { emoji: "🦁", bg: "#ff6b3e22", border: "#ff6b3e", text: "#ff6b3e" },
  { emoji: "🐧", bg: "#3eaaff22", border: "#3eaaff", text: "#3eaaff" },
  { emoji: "🐷", bg: "#ff3eb522", border: "#ff3eb5", text: "#ff3eb5" },
  { emoji: "🐬", bg: "#3effee22", border: "#3effee", text: "#3effee" },
  { emoji: "👽", bg: "#aaff3e22", border: "#aaff3e", text: "#aaff3e" },
  { emoji: "👻", bg: "#ffffff22", border: "#ffffff", text: "#ffffff" },
];
const CIRCUMFERENCE = 2 * Math.PI * 24;

export function PalavraRevealScreen() {
  const { jogadores, jogadorAtualIdx, impostoresIdx, palavraAtual, avancarRevealPalavra, rodada } = useGame();
  const [revelado, setRevelado] = useState(false);
  const [passando, setPassando] = useState(false);
  const nome = jogadores[jogadorAtualIdx];
  const ehImp = impostoresIdx.includes(jogadorAtualIdx);
  const av = AVATARS[jogadorAtualIdx % AVATARS.length];
  const palavra = ehImp ? palavraAtual?.impostor : palavraAtual?.normal;

  const continuar = () => {
    setPassando(true);
    setTimeout(() => { setRevelado(false); setPassando(false); avancarRevealPalavra(); }, 350);
  };

  if (!revelado) return (
    <div className="app-wrapper" style={{ paddingTop: 80 }}>
      <div style={{ textAlign: "center", marginBottom: 32, animation: "slideUp 0.4s ease" }}>
        <div style={{ color: "var(--text-muted)", fontSize: "0.75rem", letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 8 }}>
          Rodada {rodada} · Jogador {jogadorAtualIdx + 1} de {jogadores.length}
        </div>
        <div style={{ width: 80, height: 80, borderRadius: "50%", background: av.bg, border: `3px solid ${av.border}`, color: av.text, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "2.8rem", margin: "0 auto 16px", boxShadow: `0 0 30px ${av.border}44` }}>{av.emoji}</div>
        <div style={{ fontFamily: "'Bebas Neue'", fontSize: "2rem" }}>{nome}</div>
        <div style={{ color: "var(--text-secondary)", fontSize: "0.9rem", marginTop: 6 }}>Passe o dispositivo para este jogador</div>
      </div>
      <div className="card" style={{ maxWidth: 400 }}>
        <div className="card-body" style={{ textAlign: "center" }}>
          <div style={{ fontSize: "3rem", marginBottom: 16 }}>🔐</div>
          <p style={{ color: "var(--text-secondary)", fontSize: "0.95rem", lineHeight: 1.6, marginBottom: 24 }}>
            Apenas <strong style={{ color: "var(--text-primary)" }}>{nome}</strong> deve estar olhando.<br /><br />
            Toque para ver sua <strong style={{ color: "var(--text-primary)" }}>Palavra Secreta</strong>.
          </p>
          <button className="btn btn-primary btn-full" onClick={() => setRevelado(true)}>🔓 Revelar minha palavra</button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="app-wrapper" style={{ paddingTop: 80, opacity: passando ? 0 : 1, transition: "opacity 0.3s" }}>
      <div className="card" style={{ maxWidth: 500 }}>
        <div className="card-header">
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16 }}>
            <div style={{ width: 44, height: 44, borderRadius: "50%", background: av.bg, border: `2px solid ${av.border}`, color: av.text, display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1.4rem" }}>{av.emoji}</div>
            <span className={`badge ${ehImp ? "badge-red" : "badge-gray"}`}>{ehImp ? "🕵️ Impostor" : "👤 Jogador"}</span>
          </div>
          <div style={{ fontFamily: "'Bebas Neue'", fontSize: "1.6rem" }}>{nome}</div>
          <div style={{ color: "var(--text-muted)", fontSize: "0.75rem", textTransform: "uppercase", marginTop: 4 }}>Rodada {rodada} · Memorize sua palavra</div>
        </div>
        <div className="card-body">
          <div className="question-box" style={{ textAlign: "center", padding: "28px 20px" }}>
            <div style={{ fontSize: "0.7rem", fontWeight: 700, letterSpacing: "0.12em", textTransform: "uppercase", color: "var(--text-muted)", marginBottom: 16 }}>🔐 Sua palavra secreta</div>
            <div style={{ fontSize: "2.6rem", fontFamily: "'Bebas Neue'", letterSpacing: "0.06em", color: ehImp ? "var(--accent)" : "var(--green)" }}>{palavra}</div>
          </div>
          <div style={{ marginTop: 16, padding: 14, background: "var(--bg-elevated)", borderRadius: 10, fontSize: "0.82rem", color: "var(--text-secondary)", lineHeight: 1.5 }}>
            {ehImp ? "⚠️ Você é o impostor! Sua palavra é DIFERENTE. Dê dicas vagas!" : "💡 Dê dicas que façam sentido, mas sem revelar a palavra diretamente!"}
          </div>
        </div>
        <div className="card-footer">
          <button className="btn btn-primary btn-full" onClick={continuar}>
            {jogadorAtualIdx + 1 < jogadores.length ? "Próximo jogador →" : "🎤 Iniciar discussão →"}
          </button>
        </div>
      </div>
    </div>
  );
}

export function PalavraDiscussaoScreen() {
  const { jogadores, timerAtivo, tempoRodada, finalizarDiscussaoPalavra, rodada } = useGame();
  const [tempoAcabou, setTempoAcabou] = useState(false);
  const { tempo, porcentagem, iniciar } = useTimer(tempoRodada, () => setTempoAcabou(true));
  React.useEffect(() => { if (timerAtivo) iniciar(); }, []);
  const timerColor = porcentagem > 60 ? "var(--green)" : porcentagem > 30 ? "var(--gold)" : "var(--accent)";

  return (
    <div className="app-wrapper" style={{ paddingTop: 80, paddingBottom: 40 }}>
      <div className="card" style={{ maxWidth: 560 }}>
        <div className="card-header">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
            <div>
              <div className="title-eyebrow">🔐 Palavra Secreta · Rodada {rodada}</div>
              <h2 className="title-main" style={{ fontSize: "2rem" }}>Hora da<br /><span style={{ color: "var(--green)" }}>Discussão!</span></h2>
            </div>
            {timerAtivo && (
              <div style={{ textAlign: "center" }}>
                <svg viewBox="0 0 58 58" width="64" height="64">
                  <circle cx="29" cy="29" r="24" stroke="var(--border)" strokeWidth="4" fill="none" />
                  <circle cx="29" cy="29" r="24" stroke={timerColor} strokeWidth="4" fill="none"
                    strokeDasharray={CIRCUMFERENCE} strokeDashoffset={CIRCUMFERENCE - (CIRCUMFERENCE * porcentagem) / 100}
                    strokeLinecap="round" transform="rotate(-90 29 29)" />
                </svg>
                <div style={{ fontFamily: "'Bebas Neue'", fontSize: "1.4rem", color: timerColor, marginTop: -8 }}>{tempo}s</div>
              </div>
            )}
          </div>
          <p className="title-sub" style={{ marginTop: 8 }}>Façam perguntas uns aos outros. Descubra quem é o impostor!</p>
        </div>
        <div className="card-body" style={{ gap: 14, display: "flex", flexDirection: "column" }}>
          <div style={{ background: "var(--bg-elevated)", borderRadius: 12, padding: "16px 20px" }}>
            <div style={{ fontSize: "0.72rem", color: "var(--text-muted)", textTransform: "uppercase", marginBottom: 10 }}>👥 Jogadores</div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {jogadores.map((nome, idx) => {
                const av = AVATARS[idx % AVATARS.length];
                return <div key={idx} style={{ display: "flex", alignItems: "center", gap: 8, background: av.bg, border: `1px solid ${av.border}`, borderRadius: 20, padding: "6px 12px" }}>
                  <span>{av.emoji}</span><span style={{ fontSize: "0.82rem", fontWeight: 700, color: av.text }}>{nome}</span>
                </div>;
              })}
            </div>
          </div>
          <div style={{ background: "var(--accent-dim)", border: "1px solid var(--border-accent)", borderRadius: 12, padding: "16px 20px" }}>
            <div style={{ fontSize: "0.75rem", color: "var(--accent)", fontWeight: 700, textTransform: "uppercase", marginBottom: 8 }}>💡 Sugestões de perguntas</div>
            <div style={{ fontSize: "0.84rem", color: "var(--text-secondary)", lineHeight: 1.7 }}>
              • "O que você faria nesse lugar?"<br />
              • "Quem você encontraria aí?"<br />
              • "O que tem de especial nesse lugar?"<br />
              • "Com que frequência você vai lá?"
            </div>
          </div>
          {tempoAcabou && (
            <div style={{ background: "rgba(245,200,66,0.15)", border: "1px solid var(--gold)", borderRadius: 12, padding: "14px 18px", textAlign: "center" }}>
              <div style={{ fontSize: "1.8rem", marginBottom: 6 }}>⏰</div>
              <div style={{ fontFamily: "'Bebas Neue'", fontSize: "1.4rem", color: "var(--gold)" }}>Tempo esgotado!</div>
            </div>
          )}
        </div>
        <div className="card-footer">
          <button className="btn btn-primary" onClick={finalizarDiscussaoPalavra}>🗳️ Votar no Impostor →</button>
        </div>
      </div>
    </div>
  );
}
